export const ENABLE_LOADING = "SET_ENABLEDING"
export const DISABLE_LOADING = "DISABLE_LOADING"